import { render, staticRenderFns } from "./summerySettings.vue?vue&type=template&id=63df3c8d&"
import script from "./summerySettings.vue?vue&type=script&lang=js&"
export * from "./summerySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports